module.exports = __webpack_public_path__ + "static/logo_academiadeespecialistas-efbdb930da71d67dee4910ceb00a5bc7.png";